import { object } from 'yup';
import { loginValidationRules, registerValidationRules } from './rules';

const loginValidationSchema = object().shape(loginValidationRules);
const registerValidationSchema = object().shape(registerValidationRules);

export { loginValidationSchema, registerValidationSchema };
